













const namespace = 'calendar';
import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { AppTheme } from '@/plugins/vuetify/themes/types';

@Component({
    name: 'ThemeChanger',
    components: {},
})
export default class ThemeChanger extends Vue {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('changeVariant', { namespace }) private changeVariant: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('changeTheme', { namespace: 'configuration' }) private changeTheme: any;
    @Getter('appTheme', { namespace: 'configuration' }) private appTheme!: AppTheme;
    @Getter('appThemes', { namespace: 'configuration' }) private appThemes!: { [name: string]: AppTheme };

    private get getSelected() {
        return { name: this.appTheme.name, value: this.appTheme };
    }

    private get items() {
        return Object.values(this.appThemes).map((t: AppTheme) => ({ name: t.name, value: t }));
    }

    private setTheme(appTheme: AppTheme) {
        this.changeTheme(appTheme.id);
        this.changeVariant(appTheme.id);
    }
}
